import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addLeadSource, getLeadSource, updateLeadSource, deleteLeadSource } from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class LeadSource extends Component {
    constructor(props) {
        super(props)
        this.state = {
            leadsource: ''
        }
        this.handleLeadSourceSubmit = this.handleLeadSourceSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (leadsource) => {
        this.setState({ leadsource: leadsource });
        this.setState({ deleteModal: true });
    };

    handleDeleteLeadSource = () => {
        const { onDeleteLeadSource } = this.props;
        const { leadsource } = this.state;

        if (leadsource.id !== undefined) {
            onDeleteLeadSource(leadsource);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleLeadSourceSubmit(value) {
        this.props.addLeadSource(value, this.props.history);
    }

    componentDidMount() {
        const { onGetLeadSource } = this.props;
        onGetLeadSource(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { leadsources } = this.props;
        if (!isEmpty(leadsources) && size(prevProps.leadsources) !== size(leadsources)) {
            this.setState({ leadsources: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ leadsource: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const leadsource = arg;
        this.setState({
            leadsource: {
                id: leadsource.id,
                leadSourceId: leadsource.leadSourceId,
                leadSourceTitle: leadsource.leadSourceTitle,
                agentId: leadsource.agentId
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { leadsources, onUpdateAppLeadSource } = this.props;
        const { isEdit, deleteModal } = this.state;
        const leadsource = this.state.leadsource;
        //
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteLeadSource}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Lead Sources")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        leadSourceTitle: (this.state && this.state.leadSourceTitle) || "",

                                    }}
                                    validationSchema={Yup.object().shape({
                                        leadSourceTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleLeadSourceSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <CardTitle className="mb-4">Lead Source</CardTitle>
                                                    <Row>


                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="leadSourceTitle">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="leadSourceTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.leadSourceTitle && touched.leadSourceTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="leadSourceTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="leadSourceTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(leadsources, (leadsource, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                        <td>{leadsource.leadSourceTitle}</td>
                                                                        <td>
                                                                             {leadsource.agentId > 0 ? (
                                                                            <>
                                                                              <ActionEdit onClick={() => this.toggleRightCanvas(leadsource)} />
                                                                                                                                                    
                                                                              <ActionDelete onClick={() => this.onClickDelete(leadsource)} />
                                                                           </>
                                                                        ) : null}   
                                                                        
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: leadsource.id,
                                        leadSourceId: leadsource.leadSourceId,
                                        leadSourceTitle: leadsource.leadSourceTitle,
                                        agentId: leadsource.agentId

                                    }}
                                    validationSchema={Yup.object().shape({
                                        leadSourceTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                                leadSourceId: values.leadSourceId,
                                                leadSourceTitle: values.leadSourceTitle,
                                                agentId: values.agentId
                                            };
                                            onUpdateAppLeadSource(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                                <Col sm="12">
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="leadSourceTitle">
                                                            {this.props.t("Title *")}
                                                        </Label>
                                                        <SafeField
                                                            name="leadSourceTitle"
                                                            onChange={handleChange}

                                                            type="text"

                                                            className={
                                                                "form-control" +
                                                                (errors.leadSourceTitle && touched.leadSourceTitle
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }

                                                            id="leadSourceTitle"
                                                        />
                                                        <ErrorMessage
                                                            name="leadSourceTitle"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </FormGroup>

                                                </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
LeadSource.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addLeadSource: PropTypes.func,
    onGetLeadSource: PropTypes.func,
    leadsources: PropTypes.array,
    onDeleteLeadSource: PropTypes.func,
    onUpdateAppLeadSource: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        leadsources: AppoinmentObject.leadsources,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addLeadSource: (data) => dispatch(addLeadSource(data)),
    onGetLeadSource: (agentId) => dispatch(getLeadSource(agentId)),
    onDeleteLeadSource: (id) => dispatch(deleteLeadSource(id)),
    onUpdateAppLeadSource: (data) => dispatch(updateLeadSource(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LeadSource))
